/* eslint-disable */
import React, { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import StageTracker from "../../../ui-components/stage-tracker/stage-tracker";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import {
  fetchAuthenticationSignUp,
  fetchOrganisationUserPost,
} from "../../../services/api-raindrop";
import { isLocalEnvironment } from "../../../services/environment.js";
import { Size } from "../../../logic/enums.ts";

const ContentEmail = ({ email, setEmail, onMoveToNextStage }) => {
  const [isValid, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  useEffect(() => {
    if (email.includes("@") && email.includes(".")) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [email]);

  const onSubmit = () => {
    setIsLoading(true);
    fetchOrganisationUserPost({
      email: email,
    })
      .then((data) => {
        onMoveToNextStage();
      })
      .catch((error) => {
        setErrorMessage("Something went wrong. Please try again.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const random = Math.floor(Math.random() * 1000);
  return (
    <div className="flex flex-col gap-16 w-full max-w-md items-center ">
      <div className="flex flex-col gap-4 items-center">
        <div className="text-3xl font-bold">Tell us about yourself</div>
        <div className="text-color-dark-text-secondary text-center">
          Enter your work email address to register your organisation with The
          Raindrop Company.
        </div>
      </div>

      <RaindropInput
        example={`ben.franky.${random}@yourcompany.com`}
        isLarge={true}
        value={email}
        onChange={(e) => {
          setEmail(e.target.value);
        }}
        errorMessage={errorMessage}
      />

      <RaindropButton
        title="Continue"
        style={ButtonStyle.Primary}
        size={Size.Large}
        isDisabled={!isValid}
        onClick={onSubmit}
        isLoading={isLoading}
      />
    </div>
  );
};

const ContentAdditionalDetails = ({
  email,
  setEmail,
  onMoveToNextStage,
  setUrlMagicLink,
}) => {
  const [nameLegal, setNameLegal] = useState();
  const [namePreferred, setNamePreferred] = useState();
  const [dateOfBirth, setDateOfBirth] = useState();
  const [addressLine1, setAddressLine1] = useState();
  const [city, setCity] = useState();
  const [postcode, setPostcode] = useState();

  const [isLoading, setIsLoading] = useState(false);

  let randomInteger = Math.floor(Math.random() * 1000);
  let randomEmail = `sam.sammison.${randomInteger}@example.com`;

  const onClickContinue = () => {
    setIsLoading(true);

    fetchAuthenticationSignUp({
      email: email,
      application: "cirrus",
      nameLegal: nameLegal,
      namePreferred: namePreferred,
      dateOfBirth: dateOfBirth,
      addressLine1: addressLine1,
      city: city,
      postcode: postcode,
    })
      .then((data) => {
        onMoveToNextStage();

        if (isLocalEnvironment()) {
          setUrlMagicLink(data?.url_magic_link);
        }
      })
      .catch((error) => {
        console.log("(RD-1343)", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="flex flex-col h-full gap-12 w-full">
      <div className="flex flex-col gap-4">
        <div className="text-3xl font-bold">Sign up</div>
        <div className="text-color-dark-text-secondary">
          Enter your email address to sign up for Cirrus.
        </div>
      </div>

      <div className="flex flex-row w-full gap-4">
        <div className="flex flex-col gap-4 w-full">
          <RaindropInput
            icon={""}
            example={"Sam Sammison"}
            value={nameLegal}
            label="Legal Name"
            isShowLabel={true}
            onChange={(e) => {
              setNameLegal(e.target.value);
            }}
          />
          <RaindropInput
            icon={""}
            label={"Preferred Name"}
            example={"Sam"}
            value={namePreferred}
            isShowLabel={true}
            onChange={(e) => {
              setNamePreferred(e.target.value);
            }}
          />

          <RaindropInput
            icon={""}
            example={"2000-01-01"}
            label={"Date of Birth"}
            value={dateOfBirth}
            isShowLabel={true}
            onChange={(e) => {
              setDateOfBirth(e.target.value);
            }}
          />
        </div>
        <div className="flex flex-col gap-4 w-full">
          <RaindropInput
            icon={""}
            example={"address_full_match"}
            label={"Address Line 1"}
            value={addressLine1}
            isShowLabel={true}
            onChange={(e) => {
              setAddressLine1(e.target.value);
            }}
          />
          <RaindropInput
            icon={""}
            example={"London"}
            label={"City"}
            value={city}
            isShowLabel={true}
            onChange={(e) => {
              setCity(e.target.value);
            }}
          />
          <RaindropInput
            icon={""}
            example={"E1 1AA"}
            label={"Postcode"}
            value={postcode}
            isShowLabel={true}
            onChange={(e) => {
              setPostcode(e.target.value);
            }}
          />
        </div>
      </div>

      <div className="flex flex-col gap-4 w-full justify-center items-center">
        <RaindropButton
          title="Send Magic Link"
          onClick={onClickContinue}
          style={ButtonStyle.Primary}
          isLoading={isLoading}
          size={Size.Large}
        />
        <RaindropButton
          title="Back"
          to={"/cirrus/entry"}
          style={ButtonStyle.Secondary}
          size={Size.Large}
        />
      </div>
    </div>
  );
};

const StageMagicLinkSent = ({ onBack, urlMagicLink }) => {
  return (
    <div className="flex flex-col gap-12 items-center">
      <i className="fas fa-paper-plane text-7xl text-color-dark-text-tertiary"></i>

      <div className="text-center text-color-dark-text-tertiary">
        Please click the link in the email we just sent you.
      </div>

      <RaindropButton
        title={"Back"}
        onClick={onBack}
        icon={"fa-arrow-left"}
        style={ButtonStyle.Secondary}
      />

      {isLocalEnvironment() && urlMagicLink && (
        <RaindropButton
          to={urlMagicLink}
          title="Click here (local only)"
          style={ButtonStyle.Primary}
          icon="fa-bomb"
        />
      )}
    </div>
  );
};

const CirrusSignUp = ({}) => {
  const [stageIndex, setStageIndex] = useState(0);

  const [email, setEmail] = useState("");

  const [urlMagicLink, setUrlMagicLink] = useState(null);
  // Only to be used for local development

  const onMoveToNextStage = () => {
    setStageIndex(stageIndex + 1);
  };

  return (
    <div className={"flex flex-col h-full w-ful items-center "}>
      {stageIndex === 0 && (
        <ContentEmail
          email={email}
          setEmail={setEmail}
          onMoveToNextStage={onMoveToNextStage}
        />
      )}

      {stageIndex === 1 && (
        <ContentAdditionalDetails
          email={email}
          setEmail={setEmail}
          onMoveToNextStage={onMoveToNextStage}
          setUrlMagicLink={setUrlMagicLink}
        />
      )}

      {stageIndex === 2 && (
        <StageMagicLinkSent
          onBack={() => {
            setStageIndex(0);
          }}
          urlMagicLink={urlMagicLink}
        />
      )}
    </div>
  );
};

export default CirrusSignUp;
